import React from 'react';
import './style.scss';
import alert from '@assets/images/preview-alert.svg'

const PreviewBanner = React.forwardRef((props, ref) => {
    return (
        <div ref={ref} className="flex w-100 justify-center items-center preview-banner">
            <img src={alert} alt='preview banner' />
            <div>
                This is a preview. Do not share this link with clients.
            </div>
        </div>
    );
});

export default PreviewBanner;